(function () {
    'use strict';
    angular
        .module('app')
        .factory('editEmailsService', editEmailsService);
    editEmailsService.$inject = ['$http', '$q', '$filter', '$mdDialog'];
    function editEmailsService($http, $q, $filter, $mdDialog) {
        var service = {
            loading: false,
            incoming: "",
            ProcessNtfItemXfers: ProcessNtfItemXfers,
            sendEmails: sendEmails,
            showEditEmailsDialog: showEditEmailsDialog,
            editEmail: {},
            umToDisplay: umToDisplay
        };
        return service;

        function ProcessNtfItemXfers(emails) {
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SelectionCommand/NtfItemXfers';
            $http({
                url: url,
                method: 'POST',
                data: JSON.stringify(emails),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function sendEmails(emails) {
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SelectionCommand/SendEmails';
            $http({
                url: url,
                method: 'POST',
                data: JSON.stringify(emails),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function showEditEmailsDialog(emails) {
            if (emails != null && emails.length > 0) {
                service.incoming = emails;
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/editEmails/templates/editEmails.html',
                    controller: 'editEmails',
                    fullscreen: false,
                    locals: {
                    }
                });
            }
        }

        function umToDisplay(umList) {
            var sTo = "";
            angular.forEach(umList, function (um) {
                if (sTo.length > 0)
                    sTo = sTo + "; ";
                if (um.Id == null || um.Id.length < 1)
                    sTo = sTo + um.EmailAddress;
                else
                    sTo = sTo + um.UserName;
            });
            return sTo;
        }

    }
})();